import { render, staticRenderFns } from "./EditSub.vue?vue&type=template&id=da0fb7a6&scoped=true&"
import script from "./EditSub.vue?vue&type=script&lang=js&"
export * from "./EditSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0fb7a6",
  null
  
)

export default component.exports